export const MIN_ITEM_WIDTH_CELLS = 6;
export const MIN_ITEM_HEIGHT_CELLS = 4;
export const INITIAL_GHOST_GRID_DIMENSIONS = { rows: 2, columns: 3 };

export const DASHBOARD_ACTION_BAR_HEIGHT = '4rem';
export const DASHBOARD_ACTION_BAR_HEIGHT_PX = 64;

export const RESIZE_HANDLE_PADDING = '6px';
export const RESIZE_HANDLE_PADDING_PX = 6;
